function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.85 168.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M139.61,22.31s-17.9,19.76-17.9,47.02,20.17,44,20.17,44c0,0,9.2-7.06,9.2-51.31,13.61,15.32-.57,96.44-63.35,96.44s-71.86-27.04-71.86-27.04c0,0,18.72,37.06,72.23,37.06s79.73-53.32,79.73-84.34c0-38.01-28.24-61.83-28.24-61.83Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.45,18.72S113.81,0,84.8,0,0,24.2,0,89.25c0,13.61,7,26.47,7,26.47v-26.28C7,49.16,51.6,9.45,84.8,9.45c38.11,0,49.65,9.27,49.65,9.27Z",
    style: {
      fill: "#e7b774",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79,82.07h-16.64v55.4s11.16,9.45,16.64,8.7v-64.1Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,59.75v90.58s7.19,4.73,16.26,3.4V59.75h-16.26Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87,41.98v111.19s12.51-.37,16.67-4.72V41.98h-16.67Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.ee877a0bfec3a0710abb5230101f1805.svg";
export { ForwardRef as ReactComponent };